import { render, staticRenderFns } from "./richText.vue?vue&type=template&id=4c26c552&scoped=true"
import script from "./richText.vue?vue&type=script&lang=js"
export * from "./richText.vue?vue&type=script&lang=js"
import style0 from "./richText.vue?vue&type=style&index=0&id=4c26c552&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c26c552",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c26c552')) {
      api.createRecord('4c26c552', component.options)
    } else {
      api.reload('4c26c552', component.options)
    }
    module.hot.accept("./richText.vue?vue&type=template&id=4c26c552&scoped=true", function () {
      api.rerender('4c26c552', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operationManagement/customPage/components/richText.vue"
export default component.exports